/**
 * API Utility
 * Wraps fetch calls with authentication and handles 401 errors
 */

/**
 * Handle unauthorized response - clear auth and redirect to login
 */
function handleUnauthorized() {
  localStorage.removeItem('authToken');
  localStorage.removeItem('tokenExpiry');
  localStorage.removeItem('currentUser');
  localStorage.removeItem('userRole');
  localStorage.removeItem('earlyAccess');
  localStorage.removeItem('requirePasswordChange');
  
  // Redirect to login page
  window.location.href = '/login';
}

/**
 * Authenticated fetch wrapper
 * Automatically adds auth header and handles 401 responses
 * 
 * @param {string} url - The URL to fetch
 * @param {object} options - Fetch options (method, body, etc.)
 * @returns {Promise<Response>} - The fetch response
 */
export async function authFetch(url, options = {}) {
  const token = localStorage.getItem('authToken');
  
  // Merge headers with auth token
  const headers = {
    ...options.headers,
    'Authorization': `Bearer ${token}`
  };
  
  const response = await fetch(url, {
    ...options,
    headers
  });
  
  // Handle 401 Unauthorized - token is invalid or expired
  if (response.status === 401) {
    handleUnauthorized();
    // Throw to prevent further processing
    throw new Error('Session expired. Please log in again.');
  }
  
  return response;
}

/**
 * GET request with authentication
 * @param {string} url - The URL to fetch
 * @returns {Promise<Response>}
 */
export function authGet(url) {
  return authFetch(url, { method: 'GET' });
}

/**
 * POST request with authentication
 * @param {string} url - The URL to fetch
 * @param {object} data - The data to send
 * @returns {Promise<Response>}
 */
export function authPost(url, data) {
  return authFetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  });
}
